import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Liability } from '../../models/liability.model';

@Component({
standalone: false,
  selector: 'app-hide-liability-confirmation-dialog',
  styleUrls: ['./hide-liability-confirmation-dialog.component.scss'],
  templateUrl: './hide-liability-confirmation-dialog.component.html',
})
export class HideLiabilityConfirmationDialogComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public liability: Liability) {}
}
